import * as THREE from "three";
import { Scene } from "../_common/3d";
import ThreeScene from "./ThreeScene";

let initialized = false;
let threeScene;
let showing = false;
let cleanupTimeout = null;

const transitionIn = () => {
  if (showing) return;

  showing = true;

  Scene()
    .changeBackgroundColor({ color: new THREE.Color(0x000000) })
    .showHideGrid(false);

  threeScene.startScene();
};

const transitionOut = () => {
  if (!threeScene || !showing) return;

  showing = false;

  threeScene.stopScene();

  cleanupTimeout = setTimeout(() => {
    threeScene.destroy();
    Scene().remove(threeScene);
    threeScene = null;
    initialized = false;
    Scene().renderer.renderLists.dispose();
  }, 2000);
};

const create = () => {
  clearTimeout(cleanupTimeout);

  if (initialized) return;

  initialized = true;
  threeScene = ThreeScene({
    position: { x: 0, y: 0, z: 80 },
  });

  Scene().add(threeScene);
};

export { create, transitionIn, transitionOut };
